"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createVimeoContentStyle;

function createVimeoContentStyle(_ref) {
  var videoHeight = _ref.videoHeight;
  return {
    border: 0,
    height: videoHeight,
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVWaW1lb0NvbnRlbnRTdHlsZSIsInZpZGVvSGVpZ2h0IiwiYm9yZGVyIiwiaGVpZ2h0Iiwid2lkdGgiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvVmltZW9Db250ZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFN0cmljdFN0eWxlT3B0aW9ucyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZVZpbWVvQ29udGVudFN0eWxlKHsgdmlkZW9IZWlnaHQgfTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgYm9yZGVyOiAwLFxuICAgIGhlaWdodDogdmlkZW9IZWlnaHQsXG4gICAgd2lkdGg6ICcxMDAlJ1xuICB9O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRWUsU0FBU0EsdUJBQVQsT0FBc0U7RUFBQSxJQUFuQ0MsV0FBbUMsUUFBbkNBLFdBQW1DO0VBQ25GLE9BQU87SUFDTEMsTUFBTSxFQUFFLENBREg7SUFFTEMsTUFBTSxFQUFFRixXQUZIO0lBR0xHLEtBQUssRUFBRTtFQUhGLENBQVA7QUFLRCJ9